export enum STEP_STATUS {
  IN_PROGRESS = 'inprogress',
  COMPLETED = 'completed',
  PENDING = 'pending',
}
